<div class="login-page">


    <!-- ==========================
    PANEL IZQUIERDO
    =========================== -->


    <section class="left-panel">


        <div class="left-overlay"></div>


        <div class="left-content">


            <span class="badge-system">
                <i class="mdi mdi-shield-check-outline"></i>
                SISTEMA EMPRESARIAL
            </span>


            <h1>
                Sistema de Control
                <br>
                Volumétrico
            </h1>


            <p>
                Plataforma integral para el monitoreo,
                administración y cumplimiento regulatorio
                de controles volumétricos.
            </p>


            <div class="feature-list">


                <div class="feature-card">


                    <div class="icon">
                        <i class="mdi mdi-shield-lock-outline"></i>
                    </div>


                    <div>


                        <h4>Seguridad</h4>


                        <small>Acceso protegido y cifrado.</small>


                    </div>


                </div>


                <div class="feature-card">


                    <div class="icon">
                        <i class="mdi mdi-chart-line"></i>
                    </div>


                    <div>


                        <h4>Reportes</h4>


                        <small>Información disponible en tiempo real.</small>


                    </div>


                </div>


                <div class="feature-card">


                    <div class="icon">
                        <i class="mdi mdi-cloud-outline"></i>
                    </div>


                    <div>


                        <h4>Plataforma</h4>


                        <small>Disponible desde cualquier lugar.</small>


                    </div>


                </div>


            </div>


            <div class="bottom-note">


                <i class="mdi mdi-check-decagram"></i>
                Cumplimos con los más altos estándares
                de seguridad y regulación.
            </div>


        </div>


    </section>


    <!-- ==========================
    PANEL DERECHO
    =========================== -->


    <section class="right-panel">


        <div class="login-card">


            <div class="login-header">


                <img *ngIf="scope  !=='corporate' "
                    [src]="logo_img | imagenCompany"
                    class="logo"
                    alt="Logo"
                     (load)="onLogoLoaded()"
                    (error)="onLogoError()"
                >

                <img *ngIf="scope  ==='corporate' "
                    src="assets/images/volumetricos.png"
                    class="logo"
                    alt="Logo"
                     (load)="onLogoLoaded()"
                    (error)="onLogoError()"
                >


                <h2>Bienvenido</h2>


                <p>
                    Inicia sesión para acceder
                    a la plataforma.
                </p>

                <div
                        class="login-alert"
                        *ngIf="showerror"
                        role="alert"
                    >
                        <div class="login-alert-icon">
                            <i class="mdi mdi-alert-circle-outline"></i>
                        </div>

                        <div class="login-alert-content">
                            <strong>Error de acceso</strong>
                            <span>{{ error }}</span>
                        </div>

                        <button
                            type="button"
                            class="login-alert-close"
                            (click)="showerror = false"
                            aria-label="Cerrar"
                        >
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>

            </div>


            <form
                [formGroup]="loginForm"
                (ngSubmit)="submitLogin()"
            >


                <!-- Correo -->


                <div class="form-group">


                    <label>Correo electrónico</label>


                    <div
                        class="input-box"
                        [class.input-error]="
            loginForm.get('email')?.invalid &&
            (loginForm.get('email')?.dirty || loginForm.get('email')?.touched) || submitted
        "
                    >


                        <i class="mdi mdi-email-outline"></i>


                        <input
                            type="email"
                            formControlName="email"
                            placeholder="correo@empresa.com"
                            [class.is-invalid]="
                                loginForm.get('email')?.invalid &&
                                (loginForm.get('email')?.dirty || loginForm.get('email')?.touched) || submitted
                            "
                        >


                    </div>


                    <div
                        class="invalid-feedback d-block"
                        *ngIf="
                                    loginForm.get('email')?.invalid &&
                                    (loginForm.get('email')?.dirty || loginForm.get('email')?.touched) ||submitted
                                "
                    >


                        <small *ngIf="loginForm.get('email')?.errors?.['required'] || submitted">El correo electrónico es obligatorio.</small>


                        <small *ngIf="loginForm.get('email')?.errors?.['email'] || submitted">Ingresa un correo electrónico válido.</small>


                    </div>



                </div>


                <!-- Password -->


                <div class="form-group">


                    <div class="label-row">


                        <label>Contraseña</label>


                        <a href="#">¿Olvidaste tu contraseña?</a>


                    </div>


                    <div
                        class="input-box"
                        [class.input-error]="
            loginForm.get('password')?.invalid &&
            (loginForm.get('password')?.dirty || loginForm.get('password')?.touched || submitted)
        "
                    >


                        <i class="mdi mdi-lock-outline"></i>


                        <input
                            [type]="showPassword ? 'text' : 'password'"
                            formControlName="password"
                            placeholder="Ingrese su contraseña"
                            [class.is-invalid]="
                loginForm.get('password')?.invalid &&
                (loginForm.get('password')?.dirty || loginForm.get('password')?.touched || submitted)
            "
                        >


                        <button
                            type="button"
                            (click)="showPassword=!showPassword"
                        >


                            <i
                                class="mdi"
                                [ngClass]="showPassword ? 'mdi-eye-off':'mdi-eye'"
                            >
                            </i>


                        </button>


                    </div>
                    <div
                        class="invalid-feedback d-block"
                        *ngIf="
                                loginForm.get('password')?.invalid &&
                                (loginForm.get('password')?.dirty || loginForm.get('password')?.touched || submitted)
                            "
                    >


                        <small *ngIf="loginForm.get('password')?.errors?.['required'] || submitted">La contraseña es obligatoria.</small>


                    </div>
                </div>


             <button
                class="btn-login"
                type="submit"
                [disabled]="!logoLoaded || isLoading"
            >
                <ng-container *ngIf="!isLoading; else loadingTemplate">
                    <i class="mdi mdi-login"></i>
                    Iniciar Sesión
                </ng-container>

                <ng-template #loadingTemplate>
                    <span class="login-spinner"></span>
                    <span>Iniciando sesión...</span>
                </ng-template>
            </button>

            </form>


            <div class="login-footer">


                <img
                    src="assets/images/volumetricos.png"
                    class="footer-logo"
                >


                <p>
                    © 2026
                    <b class="text-info">MBQ</b>
                </p>


                <small>eSCV · Sistema de Control Volumétrico</small>


                <span class="version">Versión 2.1.0</span>


            </div>


        </div>


    </section>


</div>
